import { remove, isEmpty } from 'lodash'
import { createListViewContainer } from 'factories/ListView'
import { ISSUED_ITEMS_SAVED_KEY } from 'options/inventory/issue'
import { wrapItems, sortItems, filterBySearch, filterLocationsByGroupIds } from 'helpers/utils'
import { getPrivateItem, updatePrivateItem } from 'helpers/localForage'
import { getSharedLocations } from 'helpers/offlineData'
import Component from 'components/Issue/ReviewItems'

export default createListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: async (params = {}) => {
      const { locationGroupIds = [], locationIds = [] } = params
      const [items, locations] = await Promise.all([
        getPrivateItem(ISSUED_ITEMS_SAVED_KEY, []),
        getSharedLocations(),
      ])

      const filterLocationIds =
        isEmpty(locationIds) && !isEmpty(locationGroupIds)
          ? locations.filter(filterLocationsByGroupIds(locationGroupIds)).map((each) => each.id)
          : locationIds

      const unsortedItems = items
        .filter((each) => isEmpty(filterLocationIds) || filterLocationIds.includes(each.locationId))
        .filter(filterBySearch(params.search))

      return Promise.resolve(
        sortItems(unsortedItems, params.sortByField ?? 'timestamp', params.sortOrder ?? 'desc')
      ).then(wrapItems)
    },
    deleteItem: (id) =>
      updatePrivateItem(ISSUED_ITEMS_SAVED_KEY, [], (draft) => {
        remove(draft, (each) => each.id === id)
      }),
  }),
})(Component)
